import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {OuterPagesGuardService} from '../../../guards/outer-pages-guard.service';
import {TermsOfUseComponent} from './terms-of-use.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.termsOfUse.pageInRouting,
    data: {data: PAGES_AND_PATHS.termsOfUse},
    component: TermsOfUseComponent,
    canActivate: [OuterPagesGuardService],
    loadChildren: () => import('./terms-of-use.module').then(m => m.TermsOfUseModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TermsOfUseRoutingModule { }
